import { Filter } from '@anytag/shared-molecules';
import { FilterAction } from '@anytag/shared-types';
import { usePostReportFilter } from './hooks';
import { Template, TemplateProps } from './Template';
import { PostReportFilterFormValues } from './schema-types';

export type PostReportFilterProps = FilterAction<PostReportFilterFormValues> & Omit<TemplateProps, 'onSubmit'>;

export const PostReportFilter = ({ filter, setFilter, ...templateProps }: PostReportFilterProps) => (
  <Filter.Provider values={filter} onSubmit={setFilter} className="rounded-none">
    <Template {...templateProps} />
  </Filter.Provider>
);

export * from './schema-types';
export { usePostReportFilter };
